<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-list-view">

        <div style="margin-top: -43px;margin-bottom: 15px;">
            <vs-button radius icon="icon-plus" @click="addOpenPopup()" icon-pack="feather" class="ml-auto" style="float: right"></vs-button>
<!--            <vs-button radius icon="icon-search" @click="openAdobeSearchPopup()" v-if="userInfo.type_id === 2 || (userInfo.type_id === 3 && userInfo.has_adobe_account)" icon-pack="feather" class="ml-auto" style="float: right;margin: 0 16px;"></vs-button>-->
        </div>

        <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="items">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div
                        class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ items.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : items.length }} of {{ items.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="itemsPerPage=5"><span>5</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=10"><span>10</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=25"><span>25</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50"><span>50</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100"><span>100</span></vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
            <template slot="thead">
                <vs-th>{{ $t('id') }}</vs-th>
                <vs-th>{{ $t('name') }}</vs-th>
                <vs-th>{{ $t('company') }}</vs-th>
                <vs-th>Email</vs-th>
                <vs-th>{{ $t('phone') }}</vs-th>
                <vs-th>{{ $t('limit') }}</vs-th>
                <vs-th>{{ $t('spent') }}</vs-th>
                <vs-th v-if="userInfo.type_id === 2">{{ $t('paid') }}</vs-th>
                <vs-th v-if="userInfo.type_id === 2">{{ $t('paidHistory') }}</vs-th>
                <vs-th>{{ $t('bonus') }}</vs-th>
                <vs-th>{{ $t('MPNID') }}</vs-th>
                <vs-th>{{ $t('FinCode') }}</vs-th>
                <vs-th v-if="userInfo.type_id === 2 || (userInfo.type_id === 3 && userInfo.has_adobe_account)">{{ $t('has_adobe_account') }}</vs-th>
                <vs-th>{{ $t('status') }}</vs-th>
                <vs-th>{{ $t('createdAt') }}</vs-th>
                <vs-th>{{ $t('action') }}</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody ref="table_modal">
                <tr :data="item" :key="index" v-for="(item,index) in data">
                    <vs-td>{{ item.id }}</vs-td>
                    <vs-td>{{ item.name }}</vs-td>
                    <vs-td>{{ item.company_name }}</vs-td>
                    <vs-td>{{ item.email }}</vs-td>
                    <vs-td>{{ item.phone }}</vs-td>
                    <vs-td>{{ item.limit }}</vs-td>
                    <vs-td>{{ item.spent }}</vs-td>
                    <vs-td v-if="userInfo.type_id === 2">
                        <vs-button radius color="success" size="small" type="border" icon-pack="feather" icon="icon-plus" @click="paidPopUpOpen(item.id)"></vs-button>
                    </vs-td>
                    <vs-td v-if="userInfo.type_id === 2">
                        <vs-button radius color="success" size="small" type="border" icon-pack="feather" icon="icon-dollar-sign" @click="paidHistoryPopUpOpen(item.id)"></vs-button>
                    </vs-td>
                    <vs-td>{{ item.bonus }}</vs-td>
                    <vs-td>{{ item.mpn_id }}</vs-td>
                    <vs-td>{{ item.fin_code }}</vs-td>
                    <vs-td v-if="userInfo.type_id === 2 || (userInfo.type_id === 3 && userInfo.has_adobe_account)"><feather-icon icon="CheckIcon" v-if="item.has_adobe_account" svgClasses="h-4 w-4"/></vs-td>
                    <vs-td>{{ item.deleted_at !== null ? 'Deleted' : (item.status ? 'Active' : 'Deactive') }}</vs-td>
                    <vs-td>{{ item.created_at }}</vs-td>
                    <vs-td>
                        <a @click="getById(item.id)" style="cursor:pointer;">{{ $t('edit') }}</a>
                        <span> | </span>
                        <a v-if="item.deleted_at === null" @click="remove(item.id)" style="cursor:pointer;">{{ $t('delete') }}</a>
                        <a v-if="item.deleted_at !== null" @click="restore(item.id)" style="cursor:pointer;">{{ $t('restore') }}</a>
                    </vs-td>
                </tr>
                </tbody>
            </template>
        </vs-table>

        <vs-popup class="holamundo" v-bind:title="'User '+modalButtonText" :active.sync="addAndEditPopup">
            <div class="vx-row mb-6" v-if="userInfo.type_id !== 3">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('CompanyName') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="company_name" v-model="editOrAdd.company_name"/>
                </div>
            </div>
            <div class="vx-row mb-6" v-if="userInfo.type_id === 2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('voen') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="voen" v-model="editOrAdd.voen"/>
                </div>
            </div>
            <div class="vx-row mb-6" v-if="userInfo.type_id === 2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('contract_number') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="contract_number" v-model="editOrAdd.contract_number"/>
                </div>
            </div>
            <div class="vx-row mb-6" v-if="userInfo.type_id === 2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('contract_start_at') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <flat-pickr :config="configdateTimePicker" class="w-full" v-model="editOrAdd.contract_start_at" />
                </div>
            </div>
            <div class="vx-row mb-6" v-if="userInfo.type_id !== 3">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('MPNID') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="mpn_id" v-model="editOrAdd.mpn_id"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span v-if="userInfo.type_id === 3">{{ $t('photo') }}</span>
                    <span v-else>Logo</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <img v-if="editOrAdd.logo !== ''" :src="editOrAdd.logo" style="max-height: 100px;max-width: 100px;">
                    <br v-if="editOrAdd.logo !== ''">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <div class="vs-con-input">
                            <input type="file" name="logo" ref="logoChange" @change="logoChange"
                                   class="vs-inputx vs-input--input normal"
                                   style="border: 1px solid rgba(0, 0, 0, 0.2);">
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('full_name') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="name" v-model="editOrAdd.name"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('phone') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="phone" v-model="editOrAdd.phone"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('emailAddress') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="email" name="email" v-model="editOrAdd.email"/>
                </div>
            </div>

            <div class="vx-row mb-6" v-if="editOrAdd.id === 0">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('password') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full relative">
                    <vs-input class="w-full z-10" type="text" name="password" v-model="editOrAdd.password"/>
                    <generate-pasword class="generate-local" :active="false" @get_password="getPassword"/>
                </div>
            </div>
            <div class="vx-row mb-6" v-if="editOrAdd.id === 0">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('ConfirmPassword') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" name="password_confirmation"
                              v-model="editOrAdd.password_confirmation"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('FinCode') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" maxlength="7" name="fin_code" v-model="editOrAdd.fin_code"/>
                </div>
            </div>
            <div class="vx-row mb-6" v-if="userInfo.type_id === 3">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('group') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="con-select w-full select-large">
                        <div class="input-select-con">
                            <select v-model="editOrAdd.group_id" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :key="index" :value="item.value" v-for="(item,index) in groups">{{ item.text }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('country') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="con-select w-full select-large" v-if="userInfo.type_id === 1">
                        <div class="input-select-con">
                            <select v-model="editOrAdd.country_id" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :key="index" :value="item.id" v-for="(item,index) in countries">{{ item.name }}</option>
                            </select>
                        </div>
                    </div>
                    <vs-input v-else class="w-full" :value="country_name" disabled="disabled"/>
                </div>
            </div>

            <div class="vx-row mb-6" v-if="userInfo.type_id === 1">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('unlimited') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch color="success" name="is_unlimited" v-model="editOrAdd.is_unlimited" @change="unlimited()"/>
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('limit') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="limit" id="limit" :disabled="editOrAdd.is_unlimited || editOrAdd.is_unlimited === 1"
                              v-model="editOrAdd.limit"/>
                </div>
            </div>


            <div class="vx-row mb-6" v-if="userInfo.type_id === 1">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('MarkupGroup') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="con-select w-full select-large">
                        <div class="input-select-con">
                            <vs-select multiple v-model="editOrAdd.markup_group_ids" class="w-full select-large">
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in MarkupGroup" class="w-full" />
                            </vs-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-6" v-else-if="userInfo.type_id === 2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('MarkupGroup') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="con-select w-full select-large">
                        <div class="input-select-con">
                            <select v-model="editOrAdd.markup_group_id" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :key="index" :value="item.value" v-for="(item,index) in MarkupGroup">{{ item.text }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('need_azn_cash') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch color="success" name="status" v-model="editOrAdd.need_azn_cash"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('need_azn_credit') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch color="success" :disabled="!editOrAdd.need_azn_cash" name="status" v-model="editOrAdd.need_azn_credit"/>
                </div>
            </div>-->

            <template v-if="userInfo.type_id === 2 || (userInfo.type_id === 3 && userInfo.has_adobe_account)">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>{{ $t('need_create_adobe_account') }}</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-switch color="success" name="need_create_adobe_account" v-model="editOrAdd.need_create_adobe_account"/>
                    </div>
                </div>

                <template v-if="editOrAdd.need_create_adobe_account == true">
                    <div class="vx-row mb-6" v-if="userInfo.type_id === 3">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('CompanyName') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" name="company_name" v-model="editOrAdd.company_name"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6" v-if="userInfo.type_id === 3" v-show="editOrAdd.id == 0">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('cotermDate') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <flat-pickr :config="configCotermDateTimePicker" :key="cotermDateKey" class="w-full" v-model="editOrAdd.cotermDate" />
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('region') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <div class="con-select w-full select-large">
                                <div class="input-select-con">
                                    <select v-model="editOrAdd.region_id" class="input-select vs-select--input" style="padding: 8.8px;">
                                        <option :key="index" :value="item.id" v-for="(item,index) in regions">{{ item.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('city') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" name="city" v-model="editOrAdd.city"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('addressLine1') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" name="addressLine1" v-model="editOrAdd.addressLine1"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('addressLine2') }}</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" name="addressLine2" v-model="editOrAdd.addressLine2"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('postalCode') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" name="postalCode" v-model="editOrAdd.postalCode"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6" v-if="userInfo.type_id === 2">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('marketSegments') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <div class="con-select w-full select-large">
                                <div class="input-select-con">
                                    <vs-select multiple v-model="editOrAdd.marketSegments" class="w-full select-large">
                                        <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in ['COM', 'GOV', 'EDU']" class="w-full" />
                                    </vs-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-6" v-else-if="userInfo.type_id === 3">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('marketSegment') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <div class="con-select w-full select-large">
                                <div class="input-select-con">
                                    <vs-select v-model="editOrAdd.marketSegment" class="w-full select-large">
                                        <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in userInfo.availableMarketSegments" class="w-full" />
                                    </vs-select>
                                </div>
                            </div>
                        </div>
                    </div>


                </template>
            </template>


            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('status') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch color="success" name="status" v-model="editOrAdd.status"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button color="success" type="filled" @click="editOrAddUser()">{{ modalButtonText }}</vs-button>
                </div>
            </div>
        </vs-popup>

<!--        <vs-popup class="holamundo" v-bind:title="'Search Adobe '+(userInfo.type_id === 2 ? 'Reseller' : 'Customer')+' Account'" :active.sync="searchAdobePopup">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ (userInfo.type_id === 2 ? 'Reseller' : 'Customer') }} ID *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" v-model="adobeId"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button color="success" type="filled" @click="searchAdobeAccount()">{{ $t('search') }}</vs-button>
                </div>
            </div>
        </vs-popup>-->

        <vs-popup class="holamundo" v-bind:title="'Paid'" :active.sync="paidPopUp">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('paid') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" v-model="paid"/>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button color="success" type="filled" @click="getPaid()">{{ $t('add') }}</vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup  v-bind:title="$t('paid')" :active.sync="paidHistoryPopup">
            <div class="data-list-list-view">
                <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="paidHistoryItems">
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ paidHistoryItems.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : paidHistoryItems.length }} of {{ paidHistoryItems.length }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="itemsPerPage=5"><span>5</span></vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=10"><span>10</span></vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=25"><span>25</span></vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=50"><span>50</span></vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=100"><span>100</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <template slot="thead">
                        <vs-th>{{ $t('paid') }}</vs-th>
                        <vs-th>{{ $t('createdAt') }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody ref="table_modal">
                            <tr :data="item" :key="index" v-for="(item,index) in data">
                                <vs-td>{{ item.paid }} $</vs-td>
                                <vs-td>{{ item.created_at }}</vs-td>
                            </tr>
                        </tbody>
                    </template>
                </vs-table>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import GeneratePasword from "../ui-elements/GeneratePasword";
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        props: {
            search: {
                type: Object,
                default: {}
            }
        },
        components: {
            flatPickr,
            GeneratePasword
        },
        data() {
            return {
                configdateTimePicker: {
                    dateFormat: 'Y-m-d'
                },
                configCotermDateTimePickerDefault: {
                    dateFormat: 'Y-m-d',
                    minDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1)),
                    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3, new Date().getMonth(), new Date().getDate() + 1)),
                    defaultDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1))
                },
                configCotermDateTimePicker: {
                    dateFormat: 'Y-m-d',
                    minDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1)),
                    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3, new Date().getMonth(), new Date().getDate() + 1)),
                    defaultDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1))
                },
                cotermDateKey: 1, // 1 is for create, other random for search
                countries: [],
                regions: [],
                groups: [],
                MarkupGroup: [],
                activeConfirm: false,
                locale: this.$i18n.locale,
                userInfo: window.userInfo,
                modalButtonText: this.$t('save'),
                items: [],
                paidHistoryItems: [],
                addAndEditPopup: false,
                addAndEditPopupAuto: false,
                paidHistoryPopup: false,

                searchAdobePopup: false,
                adobeId: '',

                country_name: '',
                paidPopUp: false,
                paidUserId: 0,
                paid: 0,

                editAndAddTemplate: {
                    id: 0,
                    company_name: '',
                    voen: '',
                    contract_number: '',
                    contract_start_at: '',
                    mpn_id: '',
                    logo: '',
                    logoChange: '',
                    name: '',
                    phone: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    fin_code: '',
                    group_id: 0,
                    is_unlimited: false,
                    limit: 0,
                    markup_group_id: 0,
                    markup_group_ids: [],
                    country_id: 0,
                    status: false,
                    need_azn_cash: false,
                    need_azn_credit: false,

                    // ADOBE START
                    need_create_adobe_account: false,
                    region_id: 0,
                    city: '',
                    addressLine1: '',
                    addressLine2: '',
                    postalCode: '',
                    marketSegments: [],
                    marketSegment: '',
                    cotermDate: '',
                    // ADOBE END

                    _method: 'POST'
                },
                editOrAdd: {},
                index: '',
                show: false,
                selected: [],
                textarea: '',
                isActive: false,
                popupActive: false,
                itemsPerPage: window.itemsPerPage,
                isMounted: false,
                fromDate: null,
                toDate: null,
                configFromdateTimePicker: {
                    minDate: new Date(),
                    maxDate: null
                },
                configTodateTimePicker: {
                    minDate: null
                }
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            paidPopUpOpen(id){
                this.paidPopUp = !this.paidPopUp;
                this.paidUserId = id;
            },
            paidHistoryPopUpOpen(id){
                this.$vs.loading();
                const thisIns = this;

                axios.get(apiUrl + '/user/'+id+'/paidHistory?token=' + token)
                    .then(function (response) {
                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.paidHistoryItems = data.data;
                            thisIns.paidHistoryPopup = !thisIns.paidHistoryPopup;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });

            },
            getPaid(){
                this.$vs.loading();
                const thisIns = this;

                axios.post(apiUrl + '/user/'+this.paidUserId+'/paid?token=' + token, {paid: this.paid})
                    .then(function (response) {
                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.items = data.data;
                            thisIns.paidPopUp = false;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            openConfirm(id) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('confirm'),
                    text: this.$t('doYouWantToDelete'),
                    accept: ()=>{ this.remove(id, false) }
                })
            },
            randomIntFromInterval(min, max) { // min and max included
                return Math.floor(Math.random() * (max - min + 1) + min);
            },
            searchAdobeAccount(){
                this.$vs.loading();
                const thisIns = this;

                axios.post(apiUrl + '/user/findAdobeAccount?token=' + token, {adobeId: this.adobeId})
                    .then(function (response) {
                        let data = response.data;
                        if (data.code === 200) {
                            data = data.data;
                            let adobeId = thisIns.adobeId;
                            thisIns.adobeId = '';
                            thisIns.searchAdobePopup = false;
                            thisIns.addOpenPopup();

                            thisIns.configCotermDateTimePicker.minDate = data.cotermDate;
                            thisIns.configCotermDateTimePicker.maxDate = data.cotermDate;
                            thisIns.configCotermDateTimePicker.defaultDate = data.cotermDate;
                            thisIns.cotermDateKey = thisIns.randomIntFromInterval(2, 999999999);

                            let companyProfile = data.companyProfile;

                            thisIns.editOrAdd.adobeId = adobeId;
                            thisIns.editOrAdd.company_name = companyProfile.companyName;
                            thisIns.editOrAdd.name = companyProfile.contacts[0].firstName + ' ' + companyProfile.contacts[0].lastName;
                            thisIns.editOrAdd.phone = companyProfile.contacts[0].phoneNumber;
                            thisIns.editOrAdd.email = companyProfile.contacts[0].email;

                            thisIns.editOrAdd.need_create_adobe_account = true;
                            thisIns.editOrAdd.region_id = companyProfile.address.region_id;
                            thisIns.editOrAdd.city = companyProfile.address.city;
                            thisIns.editOrAdd.addressLine1 = companyProfile.address.addressLine1;
                            thisIns.editOrAdd.addressLine2 = companyProfile.address.addressLine2;
                            thisIns.editOrAdd.postalCode = companyProfile.address.postalCode;
                            thisIns.editOrAdd.marketSegments = companyProfile.marketSegments ? companyProfile.marketSegments : [];
                            thisIns.editOrAdd.marketSegment = companyProfile.marketSegment ? companyProfile.marketSegment : '';
                            thisIns.editOrAdd.cotermDate = data.cotermDate;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            getPassword(value) {
                this.editOrAdd.password = value;
                this.editOrAdd.password_confirmation = value;
            },
            unlimited() {
                this.editOrAdd.limit = 0;
            },
            logoChange() {
                this.editOrAdd.logoChange = '';
                if (this.$refs.logoChange.files.length > 0) {
                    this.editOrAdd.logoChange = this.$refs.logoChange.files[0];
                }
            },
            getById(id) {
                this.modalButtonText = this.$t('save');
                this.$vs.loading();
                this.editOrAdd = JSON.parse(JSON.stringify(this.editAndAddTemplate));
                this.editOrAdd.id = id;
                const thisIns = this;

                // eslint-disable-next-line no-undef
                axios.get(apiUrl + '/users/' + id + '/edit?token=' + token)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            for (var index in data.data) {
                                if (data.data.hasOwnProperty(index)) {
                                    if (thisIns.editOrAdd[index] !== undefined) {
                                        thisIns.editOrAdd[index] = (data.data[index] == null ? '' : data.data[index]);

                                        if (index === 'country_id'){
                                            thisIns.country_name = thisIns.countries.find((country) => { return country.id == data.data[index] }).name;
                                            thisIns.regions = thisIns.countries.find((country) => { return country.id == data.data[index] }).children;
                                        }
                                    }
                                }
                            }

                            if (thisIns.editOrAdd.region_id === 0) thisIns.editOrAdd.region_id = thisIns.regions[0].id;

                            thisIns.addAndEditPopup = true;
                            thisIns.addAndEditPopupAuto = false;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            editOrAddUser() {
                this.$vs.loading();
                let url = apiUrl + '/users?token=' + token;
                this.editOrAdd._method = 'POST';
                if (this.editOrAdd.id !== 0) {
                    // eslint-disable-next-line no-undef
                    url = apiUrl + '/users/' + this.editOrAdd.id + '?token=' + token;
                    this.editOrAdd._method = 'PUT';
                }

                const thisIns = this;
                let sendData = new FormData();

                for (let index in thisIns.editOrAdd) {
                    let value = thisIns.editOrAdd[index];
                    if (
                        index === 'status'
                        || index === 'is_unlimited'
                        || index === 'need_azn_cash'
                        || index === 'need_azn_credit'
                        || index === 'need_create_adobe_account'
                    ) {
                        if (value === true || value === '1' || value === 1) value = 1;
                        else value = 0;
                    }
                    if (Array.isArray(value)) {
                        for (let i = 0; i < value.length; i++) {
                            sendData.append(index + '[]', value[i]);
                        }
                    } else {
                        sendData.append(index, value);
                    }
                }

                axios.post(url, sendData)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            window.updateMyProfile();
                            if (thisIns.$refs.logoChange !== undefined) {
                                thisIns.$refs.logoChange.value = '';
                                thisIns.editOrAdd.logoChange = '';
                            }
                            thisIns.items = data.data;
                            thisIns.addAndEditPopup = false;
                            thisIns.addAndEditPopupAuto = true;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            addOpenPopup() {
                this.editOrAdd = JSON.parse(JSON.stringify(this.editAndAddTemplate));
                this.modalButtonText = this.$t('add');
                this.addAndEditPopup = true;
                this.addAndEditPopupAuto = false;
                this.country_name = this.countries.find((country) => { return country.id == this.userInfo.country_id }).name
                this.regions = this.countries.find((country) => { return country.id == this.userInfo.country_id }).children;
                this.editOrAdd.region_id = this.regions[0].id;

                this.configCotermDateTimePicker.minDate = this.configCotermDateTimePickerDefault.minDate;
                this.configCotermDateTimePicker.maxDate = this.configCotermDateTimePickerDefault.maxDate;
                this.configCotermDateTimePicker.defaultDate = this.configCotermDateTimePickerDefault.defaultDate;

                this.cotermDateKey = this.randomIntFromInterval(2, 999999999);
            },
            openAdobeSearchPopup(){
                this.adobeId = '';
                this.searchAdobePopup = true;
            },
            remove(id, needConfirm = true) {
                if (needConfirm) {
                    this.openConfirm(id);
                    return false;
                }

                const thisIns = this;
                axios.post(apiUrl + '/users/' + id + '?token=' + token, {'_method': 'DELETE'})
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            window.updateMyProfile();
                            thisIns.items = data.data;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }

                    });

            },
            restore(id) {
                const thisIns = this;
                // eslint-disable-next-line no-undef
                axios.get(apiUrl + '/users/' + id + '/restore?token=' + token)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.items = data.data;
                            //data = data.data;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }

                    });
            },
        },
        created() {
            const thisIns = this;
            // eslint-disable-next-line no-undef
            axios.get(apiUrl + '/users?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.items = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });

            // eslint-disable-next-line no-undef
            axios.get(apiUrl + '/markups/getParents?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        if (thisIns.userInfo.type_id === 1){
                            data.data.shift();
                        }
                        thisIns.MarkupGroup = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });
            // eslint-disable-next-line no-undef
            axios.get(apiUrl + '/countries/getList?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.countries = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });


            if (this.userInfo.type_id === 3) {
                // eslint-disable-next-line no-undef
                axios.get(apiUrl + '/group/getList?token=' + token)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.groups = data.data;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                    });
            }


        },
        mounted() {
            this.isMounted = true;
        },
        watch: {
            addAndEditPopup(state){
                if(!state && !this.addAndEditPopupAuto) {
                    this.addAndEditPopup = true;
                   if(confirm('Close Popup?')) {
                       this.addAndEditPopup = false;
                   }
                }
            },
            itemsPerPage(stage){
                localStorage.setItem('itemsPerPage', stage);
                window.itemsPerPage = stage;
            },
          'editOrAdd.need_azn_cash': function (state) {
            if (!state) this.editOrAdd.need_azn_credit = false;
          }
        }
    }
</script>

<style lang="scss">
    .generate-local .vs-input--input {
        position: absolute;
        z-index: 5;
        top: 0;
        width: 360px !important;
        margin: 0 !important;

        .alert {
            display: none !important;
        }

        .mt-5 {
            display: none !important;
        }
    }

    .active {

        path {
            fill: #d92121 !important;
        }
    }

    /*.vs-table--td:nth-last-child(-n+3) {
        !* .vs-table--td:nth-of-type(6), .vs-table--td:nth-of-type(7), .vs-table--td:nth-of-type(8) *!
        span {
            width: 40%;
            display: flex;
            justify-content: center;
        }
    }*/


    .ui-selected {
        background: rgba(var(--vs-primary), .05) !important;
        color: rgba(var(--vs-primary), 1);
        -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
        box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
    }

    .td-check {
        display: none !important;
    }

    .data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
